<template>
  <div class="events">
    <h1 class="main-heading">{{ $t('myReservations.pageTitle') }}</h1>
    <div class="events__wrapper">
      <transition name="trs-fade-out">
        <div class="events__row" v-if="getAllEvents && getAllEvents.length">
            <div class="events__tile" v-for="event in getAllEvents" :key="event.id" >
              <app-my-event-card :event="event" />
            </div>
        </div>
        <p v-else>{{ $t('myReservations.noReservations') }}</p>
      </transition>
      </div>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import AppMyEventCard from "@/components/AppMyEventCard";
  export default {
    name: "MyEvents",
    components: {
      AppMyEventCard
    },
    created() {
      this.fetchMyEvents()
    },
    computed: {
      ...mapGetters('myEvents', ['getAllEvents'])
    },
    methods: {
      ...mapActions('myEvents', ['fetchMyEvents'])
    }
  }
</script>
